export const languageKey = 'bsblanguage';
export const defaultLanguage = localStorage.getItem(languageKey) || 'en';
export const cdn = 'https://cultourbsb.com';
